import gql from 'graphql-tag'
import client from '@stores/apollo'
import { ISpaceDetails, IUploadedImageAsset } from '@api/types'
import { SpaceDetailsFragment } from '@api/fragments'

interface IPayload {
  data: {
    node: ISpaceDetails
  }
}

export default function assets(id: string): Promise<IUploadedImageAsset[]> {
  const variables = { id }

  return client.gql.query({ variables, query }).then(({ data: { node } }: IPayload) => node.assets)
}

const query = gql`
  query SpaceAssets($id: ID!) {
    node(id: $id) {
      ... on Space {
        id
        assets {
          id
          isDefault
          updatedAt
          url
          fileName
        }
      }
    }
  }
`
